<template>
	<div class="profile">
		<div class="title">个人信息</div>
		<Upload :action="uploadHost" 
		:show-upload-list="false" :multiple="false" :before-upload="handleBeforeUpload" :data="uploadData" :on-success="handleSuccess">
			<img :src="user.avatar||'../../assets/images/user/avatar.png' " class="avatar" />
		</Upload>
		<div class="input-box">
			<div class="title">昵称：</div>
			<input placeholder="请输入昵称" v-model="user.nickname" />
		</div>
		<div class="input-box">
			<div class="title">姓名：</div>
			<input placeholder="请输入姓名" v-model="user.real_name" />
		</div>
		<div class="input-box">
			<div class="title">手机号：</div>
			<input placeholder="请输入手机号" v-model="user.mobile" />
		</div>
		<button class="save" @click="save">保存</button>

	</div>
</template>

<script>
	
	import { updateProfile } from "@/api"
	import {
		oss
	} from '@/utils/aliyunoss.js'
	export default {
		name: 'Profile',
		components: {
			
		},
		data() {
			return {
				user: {
					nickname: '',
					mobile: '',
					real_name: '',
					avatar: '',
				},
				uploadHost: '',
				uploadData: {}
			};
		},
		mounted() {
			this.user = JSON.parse(JSON.stringify(this.$store.state.userInfo)) 
			if (!this.user.mobile) {
				this.user.mobile == ''
			}
		},
		methods: {
			handleBeforeUpload(file) {
				return oss(file.name).then(res => {
					this.uploadHost = res.host
					this.uploadData = res
				})
			},
			handleSuccess(res, file, fileList) {
				this.user.avatar = this.uploadData.oss_url + this.uploadData.key
			},
			async save() {
				let json = await updateProfile(this.user)
				this.$Notice.success({
					title: '修改成功',
				});
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.profile {
		width: 950px;
		height: 460px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;
		padding: 20px;

		.title {
			font-size: 20px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #333333;
		}

		.avatar {
			width: 90px;
			height: 90px;
			margin: 20px 0;
			border-radius: 50%;
		}

		.input-box {
			height: 40px;
			margin-bottom: 30px;
			display: flex;

			.title {
				width: 86px;
				height: 40px;
				line-height: 40px;
				font-size: 14px;
				font-weight: 400;
				color: #333333;
			}

			input {
				width: 224px;
				height: 40px;
				line-height: 40px;
				background: #FFFFFF;
				border: 1px solid #DDDDDD;
				padding-left: 20px;
				color: #333333;
			}
		}

		.save {
			width: 100px;
			height: 40px;
			line-height: 40px;
			background: #0F114A;
			text-align: center;
			font-size: 14px;
			color: #FFFFFF;
			margin-left: 86px;
			padding-bottom: 30px;
		}
	}
</style>
